export const focus = {
  bind(el: any) {
    el._mouseHandler = function () {
      el.style.outline = 'none';
    };
    el._keyHandler = function (e: any) {
      el.style.outline = '';
      if (e.code === 'Tab') el.focus();
    };
    window.addEventListener('mousedown', el._mouseHandler);
    el.addEventListener('keyup', el._keyHandler);
  },
  unbind(el: any) {
    window.removeEventListener('mousedown', el._mouseHandler);
    el.removeEventListener('keyup', el._keyHandler);
  },
};
